import { Book } from '@fable/types'
import { useBuyBook } from 'hooks'
import { pageAnchors } from 'components/page_detail'
import { Button, FlexBox } from '@fable/components'
import { Link } from 'react-scroll'
import { css } from '@fable/theme'
import { ListButton } from 'app/store/components/list_button/ListButton'
import { BookDetailPreorderNote } from './BookDetailPreorderNote'

interface Props {
  book: Book
  hasClubs?: boolean
}

export const BookDetailButtons = ({ book, hasClubs = false }: Props) => {
  const { onSelectBook, loading, preorder, button } = useBuyBook({
    book: book as Book,
  })

  const getButtons = () => {
    const primary = {
      title: button.content,
      onClick: () => onSelectBook(),
      loading,
    }

    const secondary = {
      title: `${hasClubs ? 'Join' : 'Start'} a book club`,
      anchorId: hasClubs
        ? pageAnchors.bookClubsReading.id
        : pageAnchors.startClub.id,
    }

    if (preorder)
      return {
        primary: { ...primary, disabled: button.props.disabled },
      }

    if (book?.is_out_of_catalog || !book?.can_purchase) {
      return { primary: secondary }
    }

    return {
      primary,
      secondary: {
        ...secondary,
        outline: true,
      },
    }
  }

  const { primary, secondary } = getButtons()
  const buttonsConfig = [primary]
  if (!!secondary) buttonsConfig.push(secondary)

  const buttons = buttonsConfig.map((button: any, i) => {
    const content = (
      <Button
        key={i}
        className={css`
          width: 100%;
          flex: 1 0 0;
        `}
        outline={button.outline}
        onClick={() => button.onClick && button.onClick()}
        loading={button.loading}
        disabled={button.disabled}
      >
        {button.title}
      </Button>
    )

    if (button.anchorId) {
      return (
        <Link
          key={i}
          className={css`
            flex: 1 0 0;
          `}
          to={button.anchorId}
          duration={600}
          offset={-170}
          smooth
          isDynamic
        >
          {content}
        </Link>
      )
    }

    return content
  })

  return (
    <>
      <FlexBox alignItems="center" gap="12px">
        {buttons}
        <ListButton book={book} />
      </FlexBox>
      {preorder ? (
        <BookDetailPreorderNote published_date={book?.published_date} />
      ) : null}
    </>
  )
}
